<template>
  <div class="admin-dashboard-page container">
    <div class="row">
      <div class="col-12 col-md-4">
        <create-manage />
      </div>
      <div class="col-12 col-md-4">
        <stats
          :title="`Total entries`"
          :value="totalRecips"
          :title2="`Total duplicates`"
          :value2="totalDuplicates"
          :is-loading="isLoading"
        />
      </div>
      <div class="col-12 col-md-4">
        <recipient-list />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <organization-list />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <duplicate-list />
      </div>
    </div>
  </div>
</template>

<script>
import Stats from '../../components/Admin/Stats';
import CreateManage from '../../components/Admin/CreateManage';
//import DataManagement from '../../components/Admin/DataManagement';
import OrganizationList from '../../components/Admin/OrganizationList';
import DuplicateList from '../../components/Admin/DuplicateList';
import RecipientList from '../../components/Admin/RecipientList';
import metadata from '../../util/metadata';

export default {
  name: 'AdminDashboard',
  metaInfo: {
    title: `Admin | ${metadata.GLOBAL.PAGE_TITLE}`,
    meta: [
      { name: 'description', content: 'Administration dashboard for The Salvation Army' }
    ]
  },
  components: { Stats, OrganizationList, DuplicateList, CreateManage, RecipientList },
  computed: {
    totalDuplicates() {
      return this.$store.getters.getDuplicates.length.toString();
    },
    totalRecips() {
      return this.$store.getters.getRecipCount ? this.$store.getters.getRecipCount.toString() :'0';
    },
    isLoading() {
      return this.$store.getters.getIsRecipientLoading;
    },
  },
  mounted() {
    this.$store.dispatch('getRecipientCount');
  }
}
</script>
